import {Accordion, Code, List, Stack, Text, Title} from '@mantine/core';

const SUBSCRIBER_VARIABLES = [
    {name: 'subscriber.firstname', description: 'Recipient first name'},
    {name: 'subscriber.email', description: 'Recipient email address'},
    {name: 'subscriber.id', description: 'Subscriber ID'},
];

const CONF_VARIABLES = [
    {name: 'conf.DATE_YEAR', description: 'Camp year'},
    {name: 'conf.DATE_START', description: 'Camp start date'},
    {name: 'conf.DATE_END', description: 'Camp end date'},
    {name: 'conf.REGISTRATION_FEE', description: 'Registration fee'},
    {name: 'conf.REGISTRATION_MAX', description: 'Maximum registrations'},
    {name: 'conf.REGISTRATION_LAST_REGISTER', description: 'Last registration date'},
    {name: 'conf.REGISTRATION_LAST_CANCEL', description: 'Last cancellation date'},
];

export function NewsletterVariables() {
    return (
        <Accordion variant="contained">
            <Accordion.Item value="variables">
                <Accordion.Control>
                    <Title order={5}>Template variables</Title>
                </Accordion.Control>
                <Accordion.Panel>
                    <Stack gap="md">
                        <Text size="sm" c="dimmed">
                            Use Jinja2 syntax in subject, message, and footer. Emails are sent as plain text.
                        </Text>
                        <div>
                            <Text size="sm" fw={600}>Insert a value</Text>
                            <Code block mt={4}>{'{{ subscriber.firstname }}'}</Code>
                        </div>
                        <div>
                            <Text size="sm" fw={600}>Conditional greeting</Text>
                            <Code block mt={4}>
                                {'{% if subscriber.firstname %} {{ subscriber.firstname }}{% endif %}'}
                            </Code>
                        </div>
                        <div>
                            <Text size="sm" fw={600}>subscriber (per recipient)</Text>
                            <List size="sm" mt={4}>
                                {SUBSCRIBER_VARIABLES.map((variable) => (
                                    <List.Item key={variable.name}>
                                        <Code>{variable.name}</Code> — {variable.description}
                                    </List.Item>
                                ))}
                            </List>
                        </div>
                        <div>
                            <Text size="sm" fw={600}>conf (camp settings)</Text>
                            <List size="sm" mt={4}>
                                {CONF_VARIABLES.map((variable) => (
                                    <List.Item key={variable.name}>
                                        <Code>{variable.name}</Code> — {variable.description}
                                    </List.Item>
                                ))}
                            </List>
                        </div>
                    </Stack>
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
}
